import BankDepositImportPage from './BankDepositImportPage';

export default BankDepositImportPage;
